import { Grid, Column, Button, Tag } from '@carbon/react';
import {
  ArrowRight,
  Launch,
  Chat,
  ChartBar,
  Notification,
  IbmSecurity,
} from '@carbon/icons-react'; // On utilise les icônes Carbon natives pour la cohérence parfaite
import { Link } from 'react-router-dom';
import styles from './Home.module.scss';
import { SphereLogoLight, SphereLogoDark } from '@sphere/shared/assets';
import { useThemeStore } from '@sphere/shared/data-access/store';

export default function Home() {
  const { theme } = useThemeStore();
  const Logo = theme === 'dark' ? SphereLogoDark : SphereLogoLight;

  return (
    <div className={styles.pageContainer}>
      <Grid style={{ margin: '0' }}>
        {/* === HERO SECTION === */}
        <Column lg={16} md={8} sm={4} className={styles.heroSection}>
          <div className={styles.heroPanel}>
            <Grid narrow>
              <Column lg={9} md={8} sm={4}>
                <div className={styles.heroContent}>
                  <div className={styles.heroBrand}>
                    <img src={Logo} alt="Sphere Logo" className={styles.logo} />
                    <Tag type="blue" className={styles.eyebrow}>
                      Plateforme éducative
                    </Tag>
                  </div>
                  <h1 className={styles.heroTitle}>
                    Bienvenue sur Sphere. <br />
                    <span className={styles.heroSubtitle}>
                      L'intelligence artificielle au service de l'éducation.
                    </span>
                  </h1>
                  <div className={styles.heroActions}>
                    <Button renderIcon={ArrowRight} as={Link} to="/ai">
                      Lancer IA Studio
                    </Button>
                    <Button
                      kind="tertiary"
                      renderIcon={Launch}
                      as={Link}
                      to="/docs"
                    >
                      Documentation
                    </Button>
                  </div>
                </div>
              </Column>
            </Grid>
          </div>
        </Column>

        {/* === SECTION 1: APPLICATIONS === */}
        <Column lg={16} md={8} sm={4}>
          <div className={styles.sectionHeader}>
            <h2>Applications</h2>
            <p className="cds--type-body-long-01">
              Accès direct aux modules principaux.
            </p>
          </div>
        </Column>

        {/* Ligne de cartes */}
        <Column lg={4} md={4} sm={4}>
          <Link to="/communication" className={styles.featureCard}>
            <div className={styles.iconBadge}>
              <Chat size={20} />
            </div>
            <h3 className={styles.cardTitle}>Communication</h3>
            <p className={styles.cardText}>
              Consultez les annonces et échangez par email avec vos
              interlocuteurs.
            </p>
            <span className={styles.cardArrow}>
              <ArrowRight size={18} />
            </span>
          </Link>
        </Column>

        <Column lg={4} md={4} sm={4}>
          <Link to="/analytics" className={styles.featureCard}>
            <div className={styles.iconBadge}>
              <ChartBar size={20} />
            </div>
            <h3 className={styles.cardTitle}>Suivi</h3>
            <p className={styles.cardText}>
              Consultez vos statistiques d'activité et de progression.
            </p>
            <span className={styles.cardArrow}>
              <ArrowRight size={18} />
            </span>
          </Link>
        </Column>

        <Column lg={4} md={4} sm={4}>
          <Link to="/notifications" className={styles.featureCard}>
            <div className={styles.iconBadge}>
              <Notification size={20} />
            </div>
            <h3 className={styles.cardTitle}>Notifications</h3>
            <p className={styles.cardText}>
              Retrouvez vos annonces et messages récents en un coup d'œil.
            </p>
            <span className={styles.cardArrow}>
              <ArrowRight size={18} />
            </span>
          </Link>
        </Column>

        {/* Carte "Sécurité" pour combler la ligne proprement */}
        <Column lg={4} md={4} sm={4}>
          <Link
            to="/security"
            className={`${styles.featureCard} ${styles.featureCardDark}`}
          >
            <div className={styles.iconBadgeDark}>
              <IbmSecurity size={20} />
            </div>
            <h3 className={styles.cardTitle}>Sécurité</h3>
            <p className={styles.cardText}>
              Données chiffrées et conformité RGPD assurée.
            </p>
            <span className={styles.cardArrow}>
              <ArrowRight size={18} />
            </span>
          </Link>
        </Column>
      </Grid>
    </div>
  );
}
